import Glide from "@glidejs/glide";
import { Fancybox } from "@fancyapps/ui";

export default function initGallery(selector = '.glide', options = {}) {

    Fancybox.bind();

    const element = document.querySelector(selector);
    if (!element) return;

    const defaultOptions = {
        perView: 1,
        gap: 0
    };

    const glide = new Glide(selector, { ...defaultOptions, ...options });
    glide.mount();

}
